import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
  to: string;
  label?: string;
}

export function BackButton({ to, label = 'Back' }: BackButtonProps) {
  return (
    <Link
      to={to}
      className="inline-flex items-center text-accent-green hover:opacity-80 mb-6"
    >
      <ArrowLeft className="h-5 w-5 mr-2" />
      {label}
    </Link>
  );
}